import React, {useContext} from "react";
import {CustomGallery} from "../common";
import {ContentContext} from "../../ContentContext";
import {getDirectusImage} from "../../api/directus";

function Gallery() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("gallery")) {
        return null;
    }

    const gallery = data?.gallery?.map((item) => ({
        ...item,
        imagePath: getDirectusImage(item?.image),
    }));

    return (
        <section className={"gallery"}>
            <h2>{data?.galleryTitle}</h2>
            <CustomGallery variant={"quilted"} data={gallery} />
        </section>
    );
}

export default Gallery;
